
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categoryDetails",
      function () {
        return require("private-next-pages/categoryDetails/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categoryDetails"])
      });
    }
  